import type { RoverType } from '@/components/RoverPlacementModal/RoverPlacementModal';
import { ROVER_TYPES } from '@/components/RoverPlacementModal/RoverPlacementModal';

interface OutfittingRoomProps {
  roomType: 'food' | 'energy' | 'mining' | 'water' | 'helium3';
  playerMoney: number;
  hasPurchasedRover: boolean;
  isRoverOutfitted: boolean;
  onOutfit: (roverType: RoverType) => Promise<void>;
  onBack: () => void;
}

export default function OutfittingRoom({
  roomType,
  playerMoney,
  hasPurchasedRover,
  isRoverOutfitted,
  onOutfit,
  onBack,
}: OutfittingRoomProps) {
  const roverType = ROVER_TYPES.find(r => r.id === roomType);
  if (!roverType) return null;

  const canAfford = playerMoney >= roverType.cost;
  const canOutfit = hasPurchasedRover && !isRoverOutfitted && canAfford;

  return (
    <div className="outfitting-room" data-room={roomType}>
      <h2 className="room-title">
        <span>{roverType.icon.replace('-8bit.png', '').toUpperCase()[0]}</span>
        {roverType.name.toUpperCase()}
      </h2>

      <div className="room-content">
        <div className="equipment-display">
          {/* Equipment visual placeholder */}
          <div className="equipment-placeholder">
            Equipment Display ({roomType})
          </div>
        </div>

        <div className="outfit-info">
          <p><strong>Produces:</strong> {roverType.produces}</p>
          <p><strong>Cost:</strong> {roverType.cost} CT</p>
          <p className="description">{roverType.description}</p>
        </div>

        {!hasPurchasedRover && (
          <div className="warning">⚠️ Purchase a rover first!</div>
        )}

        {isRoverOutfitted && (
          <div className="success">✅ Rover already outfitted!</div>
        )}

        {hasPurchasedRover && !isRoverOutfitted && (
          <button
            className="outfit-button"
            onClick={() => onOutfit(roverType)}
            disabled={!canOutfit}
          >
            {canAfford ? `OUTFIT ROVER - ${roverType.cost} CT` : 'INSUFFICIENT FUNDS'}
          </button>
        )}
      </div>

      <button className="back-button" onClick={onBack}>← Back to Lobby</button>
    </div>
  );
}

